import { get } from './base/index';

export default {
  getDashboardDetails: async () =>
    await get('dashboarddetails'),
};
